<template>
    <div>
        <div style="display:flex; align-items: baseline;margin-bottom: 20px">
            <h2>已购剧集</h2>
            <span style="margin-left: 20px;">用户id：{{ userData.userId }}</span>
        </div>

        <div style="padding: 0 20px;">
            <Table :columns="columns1" :data="tableData1">
            <Pages slot="footer" :page="page" :func="findData"></Pages>

            </Table>
        </div>

    </div>
</template>

<script>
import Pages from '@/components/pages'
import { getUserPayUnlockList } from '@/api/user'
export default {
  components: {
    Pages
  },
  props:{
    userData: {
      type: Object,
      default: () => ({})
    }
  },
  data() {
    return {
      page:{
        current: 1,
        size: 10,
        total: 0
      },
      tableData1:[],
      columns1: [
        {
          title:'记录id',
          key:'id'
        },
        {
          title:'解锁剧集',
          key: 'unlockSeriesName'
        },
        {
          title:'剧集对应短剧名称',
          key: 'playName'
        },
        {
          title:'解锁时间',
          key: 'unlockTimeFmt'
        },
        {
          title:'解锁方式',
          key: 'unlockTypeName'
        }
      ]
    }
  },
  methods: {
    findData(page) {
      if (page) this.page.current = page
      else this.page.current = 1
      getUserPayUnlockList({
        ...this.page,
        userId: this.userData.id
      }).then(r => {
        this.tableData1 = r.data.records
        this.page.total = r.data.total
      })
    }
  },
  mounted() {
    this.findData()
  }
}
</script>
